module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_photogallery_4.22bf398f.jpg";